"use client";
import * as React from "react";

type Props = {
  enabled?: boolean;
  /** ยกเว้นพื้นที่ที่อนุญาตให้เลือก/ก็อปได้ */
  exceptSelector?: string; // เช่น 'input, textarea, [contenteditable="true"], [data-allow-select]'
};

export default function ContentGuard({
  enabled = true,
  exceptSelector = 'input, textarea, [contenteditable="true"], [data-allow-select]'
}: Props) {
  React.useEffect(() => {
    if (!enabled) return;

    // กันเริ่ม select (ลากไฮไลต์)
    const onSelectStart = (e: Event) => {
      const t = e.target as HTMLElement | null;
      if (t && t.closest(exceptSelector)) return;
      e.preventDefault();
    };

    // กันลาก (drag) รูป/ข้อความ
    const onDragStart = (e: Event) => {
      const t = e.target as HTMLElement | null;
      if (t && t.closest(exceptSelector)) return;
      e.preventDefault();
    };

    // กันคัดลอก/ตัดในระดับอีเวนต์
    const onCopyCut = (e: ClipboardEvent) => {
      const t = e.target as HTMLElement | null;
      if (t && t.closest(exceptSelector)) return;
      e.preventDefault();
    };

    // กันคีย์ลัด Ctrl/Cmd + C / X / A (เลือกทั้งหมด)
    const onKeyDown = (e: KeyboardEvent) => {
      const isMod = e.ctrlKey || e.metaKey;
      if (!isMod) return;
      const k = e.key.toLowerCase();
      if (k === "c" || k === "x" || k === "a") {
        const t = (e.target as HTMLElement) || null;
        if (t && t.closest(exceptSelector)) return;
        e.preventDefault();
        e.stopPropagation();
      }
    };

    // ติด global listeners
    window.addEventListener("selectstart", onSelectStart, { capture: true });
    window.addEventListener("dragstart", onDragStart, { capture: true });
    window.addEventListener("copy", onCopyCut, { capture: true });
    window.addEventListener("cut", onCopyCut, { capture: true });
    window.addEventListener("keydown", onKeyDown, { capture: true });

    // เพิ่มคลาสกัน select ให้ทั้งหน้า (ยกเว้น exceptSelector)
    document.documentElement.classList.add("no-select");

    return () => {
      window.removeEventListener("selectstart", onSelectStart, { capture: true } as any);
      window.removeEventListener("dragstart", onDragStart, { capture: true } as any);
      window.removeEventListener("copy", onCopyCut, { capture: true } as any);
      window.removeEventListener("cut", onCopyCut, { capture: true } as any);
      window.removeEventListener("keydown", onKeyDown, { capture: true } as any);
      document.documentElement.classList.remove("no-select");
    };
  }, [enabled, exceptSelector]);

  return null;
}